import { render, staticRenderFns } from "./InsuranceImportList.vue?vue&type=template&id=89cfc4f6&scoped=true"
import script from "./InsuranceImportList.vue?vue&type=script&lang=js"
export * from "./InsuranceImportList.vue?vue&type=script&lang=js"
import style0 from "./InsuranceImportList.vue?vue&type=style&index=0&id=89cfc4f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89cfc4f6",
  null
  
)

export default component.exports